import script from "./LocaleDate.vue?vue&type=script&lang=js"
export * from "./LocaleDate.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__